var _linearGradient, _path, _path2, _path3, _path4, _path5, _linearGradient2, _path6, _path7, _path8, _path9, _linearGradient3, _path10, _g, _path11, _circle, _path12, _circle2, _circle3, _circle4, _path13, _circle5, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStopwatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "stopwatch_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 826.424,
    y1: 581.265,
    x2: 501.451,
    y2: 712.9,
    gradientTransform: "scale(1 -1) rotate(-9.38 -5100.143 2408.973)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M333.9.4C238.1 9.1 228.8 192.9 187.5 287c-20.5 46.7-68.8 94.8-60.3 149.8 9.6 62 72.9 80.1 121.7 74.1 120.7-14.7 172.9-141.1 180.8-260.8C434.6 176.3 450-10.1 333.9.4z",
    opacity: 0.25,
    fill: "url(#stopwatch_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M252.5 161.1v-15.3c0-5.5-4.5-10-10-10H239v-34h15.6c5.5 0 10-4.5 10-10V68.3c0-5.5-4.5-10-10-10h-66.2c-5.5 0-10 4.5-10 10v23.5c0 5.5 4.5 10 10 10H204v34h-3.5c-5.5 0-10 4.5-10 10v15.3C117.3 175.6 62.2 240 62.2 317.3c0 34 10.7 65.5 28.9 91.4-11.5 8.9-18.9 22.8-18.9 38.4 0 26.8 21.7 48.6 48.6 48.6H145c17.5 0 32.8-9.2 41.3-23.1 11.3 2.5 23.1 3.9 35.2 3.9 87.9 0 159.2-71.3 159.2-159.2-.1-77.3-55.2-141.7-128.2-156.2z",
    opacity: 0.11,
    fill: "#2626bc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221.8 75.9h35.1v52h-35.1v-52z",
    fill: "#8faaff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M221.8 75.9h35.1v16.7h-35.1V75.9z",
    fill: "#6583fe"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M270.5 154.8v-30c0-5.5-4.5-10-10-10h-42.1c-5.5 0-10 4.5-10 10v30h62.1z",
    fill: "#94b5dd"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "stopwatch_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: -81.487,
    y1: 296.295,
    x2: 560.647,
    y2: 296.295
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M398.6 296.3c0 87.9-71.3 159.2-159.2 159.2S80.2 384.2 80.2 296.3s71.3-159.2 159.2-159.2c31.3 0 60.6 9.1 85.2 24.7 27 17.1 48.5 42.1 61.2 71.8 8.2 19.2 12.8 40.4 12.8 62.7z",
    fill: "url(#stopwatch_svg__b)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M385.8 233.6c-8 13.3-22.1 22.5-38.3 23.9-11.8 1-22.8-2.1-31.8-8.1l-15.9 7c-3.3 1.5-6.6-1.9-5.2-5.2l7-15.9c-6-9-9.1-20-8.1-31.8 1.6-18.9 14-34.9 31-41.8 27.1 17.2 48.5 42.2 61.3 71.9z",
    opacity: 0.53,
    fill: "#94b5dd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M359.8 296.3c0 66.5-53.9 120.4-120.4 120.4S119 362.8 119 296.3s53.9-120.4 120.4-120.4c20.7 0 40.2 5.2 57.2 14.4 26.2 14.2 46.5 37.8 56.5 66.3 4.3 12.5 6.7 25.8 6.7 39.7z",
    fill: "#d2deff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M353.1 256.7c-1.8.4-3.7.6-5.6.8-11.8 1-22.8-2.1-31.8-8.1l-15.9 7c-3.3 1.5-6.6-1.9-5.2-5.2l7-15.9c-6-9-9.1-20-8.1-31.8.4-4.6 1.4-9.1 3-13.2 26.3 14.2 46.7 37.9 56.6 66.4z",
    opacity: 0.53,
    fill: "#94b5dd"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "stopwatch_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: 151.811,
    y1: 59.042,
    x2: 343.269,
    y2: 59.042
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#53acd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ae07d"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 80.8h-66.2c-5.5 0-10-4.5-10-10V47.3c0-5.5 4.5-10 10-10h66.2c5.5 0 10 4.5 10 10v23.5c0 5.5-4.5 10-10 10z",
    fill: "url(#stopwatch_svg__c)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 141.5,
    cy: 296.3,
    r: 5.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.3,
    cy: 296.3,
    r: 5.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.4,
    cy: 198.4,
    r: 5.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.4,
    cy: 394.2,
    r: 5.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.6,
    cy: 345.2,
    r: 5.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324.2,
    cy: 247.3,
    r: 5.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.6,
    cy: 247.3,
    r: 5.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324.2,
    cy: 345.2,
    r: 5.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.4,
    cy: 211.5,
    r: 5.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.3,
    cy: 381.1,
    r: 5.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.3,
    cy: 211.5,
    r: 5.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.4,
    cy: 381.1,
    r: 5.9
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M239.4 296.3l-14.8-14.8c-1.2-1.2-1.7-2.8-1.4-4.4l12.7-69.3c.7-3.8 6.2-3.8 6.9 0l12.7 69.3c.3 1.6-.2 3.3-1.4 4.4l-14.7 14.8zM239.4 296.3l20 5.1c1.7.4 3.1 1.7 3.6 3.4l14.3 48.8c1 3.5-3.3 6-5.8 3.5l-35.9-36c-1.2-1.2-1.7-3.1-1.3-4.8l5.1-20z",
    fill: "#6583fe"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 239.4,
    cy: 296.3,
    r: 14.8,
    fill: "#ffaf10"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M392.8 195.8c1.9-30.1-22.9-54.8-52.9-52.9-24.3 1.6-44.2 21-46.3 45.3-1 11.8 2.1 22.8 8.1 31.8l-7 15.9c-1.4 3.3 1.9 6.6 5.2 5.2l15.9-7c9 5.9 20 9.1 31.8 8.1 24.2-2.2 43.7-22.1 45.2-46.4z",
    fill: "#ffaf10"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 324.2,
    cy: 191.9,
    r: 5.6,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.1,
    cy: 191.9,
    r: 5.6,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 364,
    cy: 191.9,
    r: 5.6,
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M162.9 474.7c26.8 0 48.6-21.7 48.6-48.6s-21.7-48.6-48.6-48.6h-24.2v97.1h24.2z",
    fill: "#94b5dd"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.6,
    cy: 426.2,
    r: 48.6,
    fill: "#ffaf10"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M186.4 301.3h-14.2c-2.8 0-5-2.2-5-5s2.2-5 5-5h14.2c2.8 0 5 2.2 5 5s-2.3 5-5 5zM306.6 301.3h-14.2c-2.8 0-5-2.2-5-5s2.2-5 5-5h14.2c2.8 0 5 2.2 5 5s-2.2 5-5 5z",
    fill: "#0575e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M308.1 120.3c-3.7 0-7.5-1.4-10.3-4.3-5.7-5.7-5.7-15 0-20.7 5.7-5.7 15-5.7 20.7 0 5.7 5.7 5.7 15 0 20.7-2.9 2.9-6.6 4.3-10.4 4.3zm6.8-7.8zm-6.8-11.4c-1.2 0-2.4.4-3.3 1.3-1.8 1.8-1.8 4.7 0 6.5 1.8 1.8 4.7 1.8 6.5 0 1.8-1.8 1.8-4.7 0-6.5-.8-.9-2-1.3-3.2-1.3zM420.4 242.1c-3.9 0-7.6-1.5-10.3-4.3-5.7-5.7-5.7-15 0-20.7s15-5.7 20.7 0c5.7 5.7 5.7 15 0 20.7-2.9 2.8-6.5 4.3-10.4 4.3zm0-19.2c-1.2 0-2.4.4-3.3 1.3-1.8 1.8-1.8 4.7 0 6.5.9.9 2 1.3 3.3 1.3s2.4-.5 3.3-1.3c1.8-1.8 1.8-4.7 0-6.5-1-.8-2.1-1.3-3.3-1.3z",
    fill: "#8399fe"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M176.7 116h-3.3v-3.3c0-2.8-2.2-5-5-5s-5 2.2-5 5v3.3h-3.3c-2.8 0-5 2.2-5 5s2.2 5 5 5h3.3v3.2c0 2.8 2.2 5 5 5s5-2.2 5-5V126h3.3c2.8 0 5-2.2 5-5s-2.3-5-5-5z",
    fill: "#ff7eb8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M232.9 488h-3.3v-3.3c0-2.8-2.2-5-5-5s-5 2.2-5 5v3.3h-3.3c-2.8 0-5 2.2-5 5s2.2 5 5 5h3.3v3.3c0 2.8 2.2 5 5 5s5-2.2 5-5V498h3.3c2.8 0 5-2.2 5-5s-2.3-5-5-5zM444.8 257.2h-3.3v-3.3c0-2.8-2.2-5-5-5s-5 2.2-5 5v3.3h-3.3c-2.8 0-5 2.2-5 5s2.2 5 5 5h3.3v3.3c0 2.8 2.2 5 5 5s5-2.2 5-5v-3.3h3.3c2.8 0 5-2.2 5-5s-2.2-5-5-5z",
    fill: "#01eca5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M219.8 69.4c-2.8 0-5-2.2-5-5V53.7c0-2.8 2.2-5 5-5s5 2.2 5 5v10.8c0 2.7-2.3 4.9-5 4.9zM239.4 69.4c-2.8 0-5-2.2-5-5V53.7c0-2.8 2.2-5 5-5s5 2.2 5 5v10.8c0 2.7-2.2 4.9-5 4.9zM259 69.4c-2.8 0-5-2.2-5-5V53.7c0-2.8 2.2-5 5-5s5 2.2 5 5v10.8c0 2.7-2.2 4.9-5 4.9z",
    fill: "#ffaf10"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M387.3 224.8c6-8.2 9.8-18.1 10.5-28.7 1-15.8-4.8-31.2-15.9-42.3s-26.6-16.9-42.3-15.9c-10.7.7-20.6 4.5-28.7 10.5-11.4-5.5-23.2-9.6-35.4-12.4v-11.2c0-7.8-5.9-14.2-13.5-14.9V85.8h10.6c8.3 0 15-6.7 15-15V47.3c0-8.3-6.7-15-15-15h-66.2c-8.3 0-15 6.7-15 15v23.5c0 8.3 6.7 15 15 15H217v24.1c-7.6.7-13.5 7.2-13.5 14.9v11.3c-73.3 16.5-128.2 82.1-128.2 160.2 0 32.4 9.4 63.7 27.2 90.5-10.6 9.8-17.3 23.8-17.3 39.3 0 8.7 2.2 17.4 6.2 25.1 1.3 2.4 4.3 3.4 6.8 2.1 2.4-1.3 3.4-4.3 2.1-6.8-3.3-6.2-5.1-13.3-5.1-20.4 0-24 19.5-43.6 43.6-43.6s43.6 19.5 43.6 43.6-19.5 43.6-43.6 43.6c-7.2 0-14.4-1.8-20.7-5.2-2.4-1.3-5.5-.4-6.8 2-1.3 2.4-.4 5.5 2 6.8 7.8 4.2 16.6 6.5 25.5 6.5H163c18 0 33.9-8.9 43.6-22.5 10.8 2.2 21.8 3.3 32.9 3.3 90.6 0 164.2-73.7 164.2-164.2-.1-25.2-5.6-49.2-16.4-71.6zm-47.1-76.9c12.9-.8 25.5 3.9 34.6 13 9.1 9.1 13.8 21.7 13 34.6-1.4 21.9-18.9 39.8-40.7 41.6-10.2.9-20.1-1.6-28.6-7.3-.8-.6-1.8-.8-2.8-.8-.7 0-1.4.1-2 .4l-13.3 5.9 5.9-13.3c.7-1.6.5-3.4-.4-4.8-5.6-8.5-8.1-18.4-7.3-28.6 1.8-21.8 19.7-39.3 41.6-40.7zM201.3 70.8V47.3c0-2.8 2.2-5 5-5h66.2c2.8 0 5 2.2 5 5v23.5c0 2.8-2.2 5-5 5h-66.2c-2.8 0-5-2.3-5-5zm50.6 15v24h-25.1v-24h25.1zm-38.6 39c0-2.8 2.2-5 5-5h42.1c2.8 0 5 2.2 5 5v9.3c-8.5-1.4-17.2-2.1-26.1-2.1-8.9 0-17.6.7-26.1 2.1l.1-9.3zM85.2 296.3c0-85 69.2-154.2 154.2-154.2 22.2 0 43.4 4.6 63.4 13.6-6.5 7.1-11.2 15.9-13.2 25.7-11.3-4.9-23.2-8.2-35.4-9.6-2.7-.3-5.2 1.6-5.5 4.4-.3 2.7 1.6 5.2 4.4 5.5 12.3 1.4 24.3 4.9 35.5 10.1-.1 10.1 2.5 19.9 7.6 28.5l-5.9 13.4c-1.5 3.4-.8 7.3 1.9 9.9 2.6 2.6 6.5 3.4 9.9 1.9l13.4-5.9c8.5 5 17.9 7.6 27.8 7.6h.7c7.2 15.4 10.9 31.9 10.9 49 0 63.6-51.8 115.4-115.4 115.4-8.7 0-17.4-1-25.9-2.9-7.2-21-27.2-36.2-50.6-36.2h-10c-18.6-21.1-28.8-48.1-28.8-76.3 0-58.6 43.9-107.9 102-114.6 2.7-.3 4.7-2.8 4.4-5.5s-2.8-4.7-5.5-4.4C161.7 179 114 232.6 114 296.3c0 27.8 9.1 54.5 25.9 76.3h-1.2c-10.4 0-20.1 3-28.3 8.1-16.5-25.1-25.2-54.2-25.2-84.4zM170.8 469c13-9.8 21.4-25.3 21.4-42.8s-8.4-33-21.4-42.8c20.3 3.7 35.7 21.5 35.7 42.8-.1 21.3-15.5 39.1-35.7 42.8zm68.6-18.5c-9.3 0-18.6-.8-27.6-2.5 3-6.7 4.7-14.1 4.7-21.9 0-2.3-.2-4.5-.4-6.7 7.7 1.4 15.5 2.2 23.4 2.2 69.1 0 125.4-56.3 125.4-125.4 0-17.5-3.5-34.4-10.5-50.2 9.8-2 18.6-6.7 25.7-13.2 9 19.9 13.6 41.2 13.6 63.4-.1 85.1-69.3 154.3-154.3 154.3z",
    fill: "#0046c1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M221.1 285l1.3 1.3c-1.7 2.9-2.7 6.3-2.7 10 0 7.4 4.1 13.9 10.2 17.3l-.4 1.5c-.9 3.4.1 7.1 2.6 9.5l35.9 36c1.7 1.7 3.8 2.5 6 2.5 1.5 0 3-.4 4.4-1.2 3.4-2 4.9-5.9 3.8-9.7l-14.3-48.8c-1-3.4-3.7-6-7.1-6.9l-1.5-.4c0-3.6-1-7-2.7-9.9l1.3-1.3c2.3-2.3 3.4-5.6 2.8-8.9L248 206.7c-.8-4.1-4.2-7-8.4-7s-7.6 2.9-8.4 7L218.5 276c-.8 3.4.3 6.7 2.6 9zm18.3 1.5c5.4 0 9.8 4.4 9.8 9.8s-4.4 9.8-9.8 9.8-9.8-4.4-9.8-9.8 4.4-9.8 9.8-9.8zm31.5 62.9l-31.8-31.8.4-1.5c7.4 0 13.8-4.1 17.2-10.2l1.5.4 12.7 43.1zm-31.5-132.7l11.2 61.3-1.3 1.3c-2.9-1.7-6.3-2.7-10-2.7s-7 1-10 2.7L228 278l11.4-61.3z",
    fill: "#0046c1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M150.4 441.9h-19c.5-1.4.8-2.9.8-4.5v-6.3h6.4c2.8 0 5-2.2 5-5s-2.2-5-5-5h-6.4v-6.4c0-2.9 2.4-5.3 5.3-5.3s5.3 2.4 5.3 5.3c0 2.8 2.2 5 5 5s5-2.2 5-5c0-8.5-6.9-15.3-15.3-15.3-8.5 0-15.3 6.9-15.3 15.3v6.4h-1c-2.8 0-5 2.2-5 5s2.2 5 5 5h1v6.3c0 .7-.3 1.3-.8 1.8-2.1 2.1-2.8 5.3-1.6 8.1s3.8 4.6 6.9 4.6h23.7c2.8 0 5-2.2 5-5s-2.2-5-5-5z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.6e0c4327454f70da90ff2aa863f27ab8.svg";
export { ForwardRef as ReactComponent };